import DashboardLayout from "@/views/Layout/DashboardLayout.vue";
import Middleware from "@/middleware";

export const Roles = {
    path: "/",
    component: DashboardLayout,
    name: "Roles-Page",
    children: [{
        path: "/roles",
        name: "Roles",
        component: () =>
            import("@/modules/users/views/Roles/index.vue"),
        meta: {
            groupName: "roles",
            middlewares: [
                Middleware.auth,
                Middleware.permission,
                Middleware.signeture,
            ],
            permissions: "user-role-index",
        },
    },
    {
        path: "/roles/create",
        name: "Create role",
        component: () =>
            import("@/modules/users/views/Roles/create.vue"),
        meta: {
            groupName: "roles",
            middlewares: [
                Middleware.auth,
                Middleware.permission,
                Middleware.signeture,
            ],
            permissions: "role-create",
        },
    },
    {
        path: "/roles/:id",
        name: "Update role",
        component: () =>
            import("@/modules/users/views/Roles/update.vue"),
        meta: {
            groupName: "roles",
            middlewares: [
                Middleware.auth,
                Middleware.permission,
                Middleware.signeture,
            ],
            permissions: "role-update",
        },
    },
    ],
};

export const Admins = {
    path: "/",
    component: DashboardLayout,
    name: "Admins-Page",
    children: [{
        path: "/users",
        name: "Admins",
        component: () =>
            import("@/modules/users/views/index.vue"),
        meta: {
            groupName: "users",
            middlewares: [
                Middleware.auth,
                Middleware.permission,
                Middleware.signeture,
            ],
            permissions: "user-index",
        },
    },
    {
        path: "/create-user",
        name: "CreateUser",
        component: () =>
            import("@/modules/users/views/create.vue"),
        meta: {
            groupName: "users",
            middlewares: [
                Middleware.auth,
                Middleware.permission,
                Middleware.signeture,
            ],
            permissions: "user-create",
        },
    },
    {
        path: "/users/update/:id",
        name: "UpdateUser",
        component: () =>
            import("@/modules/users/views/update.vue"),
        meta: {
            groupName: "users",
            middlewares: [
                Middleware.auth,
                Middleware.permission,
                Middleware.signeture,
            ],
            permissions: "user-update",
        },
    },
    {
        path: "/users/view/:id",
        name: "ViewUser",
        component: () =>
            import("@/modules/users/views/view.vue"),
        meta: {
            groupName: "users",
            middlewares: [
                Middleware.auth,
                Middleware.permission,
                Middleware.signeture,
            ],
            permissions: "user-view",
        },
    },

    {
        path: "/profile",
        name: "profile",
        component: () =>
            import("@/modules/users/views/Profile/index.vue"),
        meta: {
            groupName: "users",
            middlewares: [Middleware.auth, Middleware.permission],
        },
    },
    ],
};

export const EmployeePage = {
    path: "/",
    component: DashboardLayout,
    name: "Employee-Page",
    children: [{
        path: "/employees",
        name: "EmployeePage",
        component: () =>
            import("@/modules/users/views/Employees/index.vue"),
        meta: {
            groupName: "employees",
            middlewares: [
                Middleware.auth,
                Middleware.permission,
                Middleware.signeture,
            ],
            permissions: "user-employee-index",
        },
    },
    {
        path: "/employees/create",
        name: "CreateEmployee",
        component: () =>
            import("@/modules/users/views/Employees/create_emp.vue"),
        meta: {
            groupName: "employees",
            middlewares: [
                Middleware.auth,
                Middleware.permission,
                Middleware.signeture,
            ],
            permissions: "add-employee",
        },
    },
    {
        path: "/employees/edit/:id",
        name: "EditEmployee",
        component: () =>
            import("@/modules/users/views/Employees/edit_emp.vue"),
        meta: {
            groupName: "employees",
            middlewares: [
                Middleware.auth,
                Middleware.permission,
                Middleware.signeture,
            ],
            permissions: "add-employee",
        },
    },
    ],
};